import React, { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from "../../../../store/actions";
import Autocomplete from '../../../../UI/Autocomplete/Autocomplete';
import CloseIcon from '@mui/icons-material/Close';
import { withRouter } from 'react-router-dom'
import {
  Typography, IconButton, TextField, FormControl, Dialog, FormLabel, FormControlLabel, RadioGroup, Radio, Divider, Avatar,
  Switch,
  FormHelperText,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import confirm from '../../../../UI/Confirm/confirm';
import {
  FormStyled, DoneIconStyled, DivSubmitButtons, DivFormTitle
} from '../../../../containers/Admin/Forms/styles';
import Spinner from '../../../../components/Spinner/index';
import { EAccessRole } from '../../../../store/types';

const ModalUsers = (props) => {
  const dispatch = useDispatch();

  const [isNewData, setIsNewData] = useState(true);
  const [editMode, setEditMode] = useState(false);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [orderBy, setOrderBy] = useState("name");
  const [order, setOrder] = useState("asc");

  const [reason, setReason] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("")
  const [profile, setProfile] = useState([])
  const [role, setRole] = useState("admin");
  const [accessId, setAccessId] = useState("");
  const [inspector, setInspector] = useState(false);

  const [emailConfirmation, setEmailConfirmation] = useState("");
  const [selectedSites, setSelectedSites] = React.useState([]);
  const [sitesFormated, setSitesFormated] = useState([])
  const [searchTextSites, setSearchTextSites] = useState("")

  const [emailError, setEmailError] = useState(false);
  const [sitesError, setSitesError] = useState(false);
  const [roleError, setRoleError] = useState(false);
  const [emailConfirmationError, setEmailConfirmationError] = useState(false);

  const fetchUser = useCallback(() => dispatch(actions.fetchUserByIdBySuperadmin(props.userId, props.tenantId)));

  const fetchSites = useCallback(
    () => dispatch(actions.fetchSitesForModalByTenant(props.tenantId, 1, 30, searchTextSites, order, orderBy)),
    [searchTextSites, order, orderBy]
  );

  const user = useSelector(state => state.users.user);
  const sites = useSelector(state => state.tenants.sitesForModals);

  const loadingSites = useSelector(state => state.tenants.loadingSites);
  const loadingUser = useSelector(state => state.users.loadingTenantUsers);
  const selectedTenant = useSelector(state => state.tenants.tenant);

  const isAnalyst = role === EAccessRole.analyst;

  //check if is newEntrance or editing
  useEffect(() => {
    if (props.open) {
      if (props.userId !== 'new') {
        fetchUser(props.userId);
        setIsNewData(false);
        setEditMode(false);
      } else {
        setIsNewData(true);
        setEmail('');
        setSelectedSites([]);
        setInspector(false);
      }
    }
  }, [props.open]);

  useEffect(() => {
    if (props.open) {
      if (props.userId !== 'new') {
        setName(user.name)
        setEmail(user.email)
        setProfile([user.photo])
        

        const access = user.access;

        if (access.length >= 1) {
          setAccessId(access[0]._id);
          let sites = []
          access[0].sites && access[0].sites.map(site => sites.push({ value: site._id, label: site.name }))
          setSelectedSites(sites)
          setRole(access[0].role)
          setInspector(access[0].inspector);
        }
      }
    }
  }, [user]);

  useEffect(() => {
    const dataFromRedux = sites
    let returnArray = []
    dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
    setSitesFormated(returnArray)
  }, [sites])

  useEffect(() => {
    fetchSites();
  }, [searchTextSites]);

  const inviteSignup = (body) => dispatch(actions.inviteSignupBySuperAdmin(body));
  const updateUserAccess = (body) => dispatch(actions.updateUserAccessBySuperadmin(props.userId, accessId, body))

  const handleSubmit = async e => {
    e.stopPropagation();
    e.preventDefault();

    let hasError = false;

    if (!email) {
      hasError = true;
      setEmailError(true);
    }

    if (isNewData && !emailConfirmation) {
      hasError = true;
      setEmailConfirmationError(true);
    }

    if (isNewData && email !== emailConfirmation) {
      hasError = true;
      setEmailError(true);
      setEmailConfirmationError(true);
    }

    let sitesIds = [];
    selectedSites.map(site => sitesIds.push(site.value));

    if (sitesIds.length === 0) {
      setSitesError(true)
      hasError = true;
    }

    if (!role) {
      setRoleError(true);
      hasError = true;
    }

    if (hasError) return

    let body = {};

    if (isNewData) {
      body = {
        email,
        role,
        sites: sitesIds,
        companyName: selectedTenant.name,
        inspector,
      };

      inviteSignup(body).then(result => {
        if (result === 'success') {
          props.onClose();
        }
      });
    } else {
      body = {
        role,
        sites: sitesIds,
        inspector,
      };

      updateUserAccess(body).then(result => {
        if (result === 'success') {
          setEditMode(false);
          props.onClose();
        }
      })
    }
  }

  const handleInputChangeSelectorSites = (text) => {
    setSearchTextSites(text);
  }

  const handleInputChangeSites = selected => {
    setSitesError(false);
    setSelectedSites(selected)
  }

  const onChangeEmail = (event) => {
    setEmailError(false);
    setEmailConfirmationError(false);
    return setEmail(event.target.value.toLowerCase())
  }


  const handleClose = () => {
    setEditMode(false)
  }

  const handleDeleteUser = (id) => {
    confirm(`Deseja realmente deletar esse colaborador?`,
      {
        title: 'DELETAR COLABORADOR',
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          deleteUser()
        },
      )
  }

  const deleteUser = () => {
    // deleteUsers().then(result => {
    //   if (result === 'success') {
    //     props.history.goBack()
    //   }
    // })
  }

  const onChangeConfirmationEmail = (event) => {
    setEmailError(false);
    setEmailConfirmationError(false);
    return setEmailConfirmation(event.target.value.toLowerCase())
  }

  return (
    <Dialog
      maxWidth='sm'
      fullWidth
      scroll='body'
      open={props.open}
      onClose={() => props.onClose()}
    >
      <FormStyled onSubmit={handleSubmit} style={{ ...styles.opacityContainer, opacity: loadingUser ? '0.3' : '1' }}>
        {loadingUser && <Spinner overlay />}
        <DivFormTitle>
           <Typography variant='h6'>{isNewData ? 'Cadastro de Novo' : 'Editar'} Usuário</Typography>
          {!isNewData &&
            <DivSubmitButtons>
              {editMode ?
                <>
                  <IconButton onClick={handleClose} size="large"><CloseIcon color='error' /></IconButton>
                  <IconButton type="submit" size="large"><DoneIconStyled /></IconButton>
                </> :
                <>
                  <IconButton onClick={() => setEditMode(true)} size="large"><EditIcon /></IconButton>
                  {/* <IconButton onClick={() => handleDeleteUser(props.match.params.id)} ><DeleteIcon /></IconButton> */}
                </>
              }
            </DivSubmitButtons>
          }
        </DivFormTitle>
        <Divider />
        <div style={styles.imageInput}>
          {!isNewData && profile && !profile[0] ?
            <Avatar style={styles.avatar}>FOTO</Avatar>
            : (<>
              <Avatar src={profile && profile[0] && profile[0].url} style={styles.avatar}></Avatar>
            </>)}
        </div>
        {!isNewData &&
        <FormControl variant="standard" fullWidth margin='normal' required>
          <TextField
            variant="standard"
            label="Name"
            name="name"
            onChange={event => setName(event.target.name)}
            value={name}
            disabled />
        </FormControl>}
        <FormControl variant="standard" fullWidth margin='normal' required>
          <TextField
            variant="standard"
            label='Email'
            name='email'
            onChange={event => onChangeEmail(event)}
            value={email}
            margin='normal'
            error={emailError}
            helperText="O convite sera enviado para este email"
            disabled={!isNewData} />
        </FormControl>
        {isNewData &&
        <FormControl variant="standard" fullWidth margin='normal' required>
          <TextField
            variant="standard"
            label="Confirme o Email"
            name="email"
            onChange={event => onChangeConfirmationEmail(event)}
            value={emailConfirmation}
            error={emailConfirmationError} />
        </FormControl>}
        <FormControl variant="standard" fullWidth margin='normal'>
          <Autocomplete
            isMulti
            loading={loadingSites} //sent to isLoading
            label='Sites'
            data={sitesFormated} // sent to options
            onSelectValue={handleInputChangeSites} // sent to onChange
            valueSelected={selectedSites} // sent to value
            newSearchText={handleInputChangeSelectorSites}
            name='site'
            hasError={sitesError}
            disabled={!isNewData && !editMode}
          />
        </FormControl>

        <FormControl variant="standard" component="fieldset" margin='normal'>
          <FormLabel component="legend">Tipo de Acesso</FormLabel>
          <RadioGroup
            aria-label="gender"
            name="role"
            value={role}
            onChange={event => {
              setRole(event.target.value);
            }}
            margin='normal'
          >
            <FormControlLabel value="admin" control={<Radio disabled={!isNewData && !editMode} />} label="Administrador" />
            <FormControlLabel value="analyst" control={<Radio disabled={!isNewData && !editMode} />} label="Analista" />
          </RadioGroup>
        </FormControl>
        { (isAnalyst) &&
          <FormControl fullWidth sx={{marginTop: 0}}>
            <FormControlLabel
              control={<Switch checked={inspector} onChange={e => setInspector(e.target.checked)} disabled={!isNewData && !editMode}/> }
              label={'Vistoriador'}
            />
            <FormHelperText sx={{margin: 0}}>{'Quando selecionado o tipo de acesso "Vistoriador", o usuário somente terá permissão para criar serviços e criar/adicionar fotos/adicionar comentários/completar/cancelar ações nas quais é responsável, os outros acessos de criação/atualização estarão bloqueados, os acessos de visualização permenecem os mesmos'}</FormHelperText>
          </FormControl>
        }
        {isNewData &&
        <DivSubmitButtons>
          <IconButton onClick={() => props.onClose()} size="large"><CloseIcon fontSize='large' color='error' /></IconButton>
          <IconButton type="submit" size="large"><DoneIconStyled fontSize='large' /></IconButton>
        </DivSubmitButtons>}
      </FormStyled>
    </Dialog>
  );
}

export default withRouter(ModalUsers);

const styles = {
  container: {
    padding: '10px',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  print: {
    marginRight: 5,
  },
  contentContainer: {
    margin: '30px 0',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  opacityContainer: {
    position: 'relative'
  },
  fileError: {
    color: '#f44336'
  },
  question: {
    marginTop: 20,
  },
  sectionTitleContainer: {
    display: 'flex',
    marginTop: 20,
  },
  avatarContainer: {
    display: 'flex',
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar: {
    width: 150,
    height: 150,
    marginTop: 20,
  },
  avatarButton: {
    margin: 5,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageInput: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: 10,
  },
  buttonEditImage: {
    // margin: '-58px 0 0 -146px',
    margin: '10px 0',
  }
}
